// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2eEPH","signatureBlock":"Footer_signatureBlock__2xd5y","signature":"Footer_signature__1sRKB"};